export const STORE_LINKS = {
  playStore:
    "https://play.google.com/store/apps/details?id=com.godocp.godo&pcampaignid=web_share",
  appStore: "https://apps.apple.com/ae/app/godo-app-start-trading-now/id6742449171",
};

export const FOOTER_LEGAL = [
  {
    id: "regulation",
    label: "Regulation and Authorization:",
    body:
      "“GODO LTD” (FSC License No GB20025812) is an authorized and registered limited company under the laws of Mauritius. We ensure that your account will be managed in full compliance with the rules and regulations set forth by the Financial Service Commission (FSC). The domain godocm.com is operated by GODO LTD.",
    link: { text: "godocm.com", href: "https://godocm.com" },
  },
  {
    id: "introduction",
    label: "GODO Introduction Financial Services LLC:",
    body:
      "(SCA License no: 20200000168) is an authorized and registered limited liability company under the law of the Securities Commodities Authorities (SCA), United Arab Emirates, under its exclusive partnership with GODO Limited (Mauritius) to exclusively facilitate our UAE Nationals and Residents. However, GODO Introduction is not authorized to hold clients' assets or money and all services are provided only on introduction basis.",
  },
];
